//router
import {
  Routes,
  Route,
  useNavigate,
  Outlet,
} from "react-router-dom";
//#region LayoutNotRequireLogin
 import DefaultLayout from "./layouts/LayoutNotRequireLogin";
//#endregion
//#region LayoutWithRequireLogin
import { useState, useEffect } from "react";
// import DefaultLayout from "./layouts/LayoutWithRequireLogin";
import { allowedRoles, path } from "./utils/common/constant";
import { Login, Error, NoAuth } from "./pages";
import { PrivateRoutes } from "./utils/routes/private";
import { getSessionVar } from "./utils/common/hashData";
import { sessionVar } from "./utils/common/constant";
import './App.css'
//#endregion


const ProtectedRoute = ({ isAllowed, children, redirectPath }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAllowed) {
      return navigate(redirectPath ? redirectPath : `${path.common.ADMIN}`);
    }
  }, []);

  return <>{isAllowed ? children ? children : <Outlet /> : <></>}</>;
};

function App() {
  //#region LayoutWithRequireLogin
  const navigate = useNavigate();
  // const [user, setUser] = useState(getSessionVar(sessionVar.user));
  // const handeSetUser = (userJson) => {
  //   setUser(userJson);
  // };

  // const showPrivateMenu = (routes) => {
  //   var result = null;
  //   if (routes.length > 0) {
  //     result = routes.map((route, index) => {
  //       return (
  //         <Route
  //           key={index}
  //           path={route.path}
  //           element={
  //             <ProtectedRoute
  //               isAllowed={
  //                 user
  //                   ? route.role
  //                     ? route.role.includes(user.role)
  //                     : false
  //                   : false
  //               }
  //               redirectPath={`../${path.common.NOAUTH}`}
  //             >
  //               {route.main()}
  //             </ProtectedRoute>
  //           }
  //           exact={route.exact}
  //         ></Route>
  //       );
  //     });
  //   }
  //   return result;
  // };

  // useEffect(() => {
  //   if (!user) {
  //     navigate(path.common.ADMIN);
  //   }
  // }, []);
  //#endregion

  return (
    //LayoutWithRequireLogin
      // <Routes>
      //   <Route
      //     path={path.common.ADMIN}
      //     element={<Login onSetUser={handeSetUser} />}
      //     exact={true}
      //   />
      //   <Route
      //     element={
      //       <ProtectedRoute
      //         isAllowed={user ? allowedRoles.includes(user.role) : false}
      //       >
      //         <DefaultLayout />
      //       </ProtectedRoute>
      //     }
      //   >
      //     <Route path={`${path.common.NOAUTH}`} element={<NoAuth />} />
      //     {showPrivateMenu(PrivateRoutes)}
      //   </Route>
      //   <Route path={path.common.ERROR} element={<Error />} />
      // </Routes>

    //LayoutNotRequireLogin
      <Routes>
        <Route path="/*" element={<DefaultLayout />} />
      </Routes>
  );
}

export default App;
